module.exports = __webpack_public_path__ + "static/media/Spike Lee Headshot New_1602612099771.60a6c024.png";